import { useParams } from "react-router-dom";
import ViewDetalhesCota from "../ViewDetalhesCota";
import ViewAppBar from "../ViewAppBar";
import ViewFooter from "../ViewFooter";

export default function ViewDetalhesCadastroPropriedade() {
  const { cotaUsuarioId } = useParams();
  return (
    <>
      <ViewAppBar />
      <ViewDetalhesCota cotaUsuarioId={Number(cotaUsuarioId)} />
      <ViewFooter />
    </>
  );
}
